module.exports = __webpack_public_path__ + "img/delete.2781fe57.png";